// 视图对应的组件名
// 这个配置用在了 main.vue 和 aside.vue 里面
export default {
  chat: {
    aside: 'ChatList',
    main: 'ChatArea'
  },
  contact: {
    aside: 'ContactList',
    main: 'ContactArea'
  },
  subject: {
    aside: 'SubjectList',
    main: 'SubjectArea'
  }
}



// WEBPACK FOOTER //
// ./src/config/viewConfig.js